export const LAUNCHPAD_LABEL = 'Launchpad';
export const LAUNCHPAD_DESCRIPTION =
  'Discover and set up new Postscript features.';

export const getGuideDismissalKey = (
  shopId: string | number,
  guideKey: string,
) => `launchpad_guide_dismissed_${shopId}_${guideKey}`;
